<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.searchKey"  placeholder="输入计划名称或是ID查询" />
      <el-select v-model="tableParams.state"  placeholder="所有未删除计划"
        style="margin-right: 15px; width: 210px">
        <el-option v-for="item in statusList" :label="item.lable" :value="item.value" :key="item.value" />
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
      <el-button @click="downExcel('/slot/plan/list/xlsx', '计划表格', tableParams)" @search="searchColumn"
        @refresh="toQuery" @change="changeColumn" :column="columns" type="warning" >下载</el-button>
    </div>
    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
        style="padding-bottom: 10px">
        <el-button @click="add" type="primary" size="small">创建计划</el-button>
      </table-column>
      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row size="small" class="js-table" style="width: 100%">
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth" :key="i" align="center">
          <template v-slot="scope">
            <span>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" fixed="right" width="100">
          <template v-slot="scope" align="center">
            <el-switch v-model="scope.row.state" active-color="#13ce66" :active-value="1" :inactive-value="0"
              @change="upstate(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button @click="updata(scope.row)" type="success" size="mini">修改配置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
        background layout="total,sizes,prev,pager,next" style="margin-top: 40px" />
    </div>
    <m-form ref="form" @submit="renew"></m-form>
  </div>
</template>

<script>
import initTableMixin from '@/mixins/initTable'
import BaseDatePicker from '@/components/BaseDatePicker'
import { downExcelMixin } from '@/mixins/downExcel'
import TableColumn from '@/components/TableColumn'
import mForm from './form.vue'
import { upstataplot } from '@/api/manage/plot/plot'

export default {
  name: 'managerPlot',
  mixins: [initTableMixin, downExcelMixin],
  components: {
    BaseDatePicker,
    TableColumn,
    mForm
  },
  data () {
    return {
      statusList: [
        { value: 4, lable: '所有计划' },
        { value: 0, lable: '暂停' },
        { value: 1, lable: '开启' },
        { value: 2, lable: '删除' },
        { value: 3, lable: '所有未删除计划' }
      ],
      columns: [
        { field: 'planName', title: '计划名称' },
        { field: 'planId', title: '计划ID' },
        { field: 'dailyWeight', title: '预算量级' },
        { field: 'startTime', title: '投放时间' },
        { field: 'putTime', title: '投放时段' },
        { field: 'createTime', title: '创建时间' },
        { field: 'reqSmt', title: '请求数' },
        { field: 'resSmt', title: '填充数' },
        { field: 'showSmt', title: '展示数' },
        { field: 'clkSmt', title: '点击数' },
        { field: 'clkSmtRate', title: '点击率' },
        { field: 'dpSmt', title: '唤醒数' },
        { field: 'dpSmtRate', title: '唤醒率' }
      ],
      tableParams: {
        searchKey: '',
        state: ''
      }
    }
  },
  created () { },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    beforeInit () {
      this.tableUrl = '/slot/slot/plan/list'
      return true
    },
    add () {
      this.$refs.form.show()
    },
    updata (row) {
      this.$refs.form.show(row)
    },
    toQuery () {
      this.pagination.pageNum = 1
      if (
        !this.isTime &&
        (this.tableParams.asc === 'timeHour' ||
          this.tableParams.desc === 'timeHour')
      ) {
        this.tableParams.asc = ''
        this.tableParams.desc = ''
      }
      this.init()
    },
    upstate (row) {
      const state = {
        planId: row.planId,
        state: row.state
      }
      upstataplot(state)
    },
    renew () {
      this.currentChange(this.pagination.pageNum)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select &>.base-date-picker {
    width: 400px;
  }

  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
